// @ts-check
/**
 * @prettier
 */

import React from 'react';
import PropTypes from 'prop-types';
import DraftSelectableItem from './DraftSelectableItem';
import { getLastUpdatedDate, dateToLastUpdateDateString } from '../tools/dateTools';

// @ts-ignore
import styles from './MultipleDrafts.module.less';

const MultipleDrafts = ({ drafts, selectedItemUUID, onSelectionChanged }) => {
  return (
    <div className={styles.container}>
      {drafts.map(({ project_uuid: uuid, project_name: name, customizations }) => (
        <DraftSelectableItem
          key={uuid}
          uuid={uuid}
          title={name}
          customizations={customizations}
          active={uuid === selectedItemUUID}
          lastUpdate={dateToLastUpdateDateString(getLastUpdatedDate({ customizations }))}
          onSelectDraft={onSelectionUUID => onSelectionChanged(onSelectionUUID)}
        />
      ))}
    </div>
  );
};

MultipleDrafts.propTypes = {
  drafts: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onSelectionChanged: PropTypes.func.isRequired,
  selectedItemUUID: PropTypes.string.isRequired,
};

export default MultipleDrafts;



// WEBPACK FOOTER //
// ./src/cards/components/common/modals/ExistingDraftsForCardSuiteModal/components/MultipleDrafts.jsx